var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_19)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_442_19",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.25H20V19.75H4V4.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_442_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2336 12.9721L16.4696 10.2305C16.405 9.99847 16.0759 9.99847 16.0113 10.2305L15.2473 12.9721",
    stroke: "#F8009E",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5098 12.0303H16.9711",
    stroke: "#F8009E",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6643 12.9735C10.2263 12.9735 9.87129 12.6184 9.87129 12.1804V10.8482C9.87129 10.4103 10.2263 10.0552 10.6643 10.0552C11.1023 10.0552 11.4574 10.4103 11.4574 10.8482V12.1804C11.4574 12.6184 11.1023 12.9735 10.6643 12.9735Z",
    stroke: "#F8009E",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8912 12.2453L11.6214 12.9735",
    stroke: "#F8009E",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8684 10.5368C13.8684 10.8028 13.3867 11.2945 13.3867 11.2945C13.3867 11.2945 12.9051 10.8028 12.9051 10.5368C12.9051 10.2709 13.1207 10.0552 13.3867 10.0552C13.6527 10.0552 13.8684 10.2709 13.8684 10.5368Z",
    stroke: "#F8009E",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2719 11.5968C14.2719 11.5968 14.0856 11.9657 13.9641 12.2279C13.4867 13.2582 12.7382 13.0656 12.6461 12.6094C12.5363 12.0649 13.3867 11.2945 13.3867 11.2945L14.4245 12.9722",
    stroke: "#F8009E",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63791 7.39804C8.21942 8.33207 7.30873 9.7802 7.30873 11.4059C7.30873 14.223 10.0429 16.5066 13.4157 16.5066C14.4233 16.5066 15.374 16.3028 16.2117 15.9418",
    stroke: "#F8009E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4774 12.0303C19.5076 11.8236 19.5227 11.6149 19.5227 11.4059C19.5227 8.58891 16.7885 6.30526 13.4157 6.30526C12.3317 6.30526 11.3137 6.54115 10.4313 6.95478",
    stroke: "#F8009E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7348 16.3867C14.7348 16.3867 15.8327 17.2849 17.771 17.5864C18.0753 17.6337 18.3059 17.2939 18.1767 16.9931L17.4278 15.2496L17.4285 15.251C18.2738 14.6351 18.914 13.828 19.2527 12.9104",
    stroke: "#F8009E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83203 16.8278C10.4286 16.7246 10.9815 16.5216 11.4646 16.2407",
    stroke: "#F8009E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69501 9.61763C5.83689 10.0637 4.47731 11.4936 4.47731 13.189C4.47731 14.3066 5.06804 15.3089 6.00288 15.9901L6.00342 15.9891L5.4579 17.2593C5.36375 17.4785 5.53173 17.726 5.7534 17.6915C7.16223 17.4724 7.96148 16.8207 7.96517 16.8177C8.28225 16.8759 8.60396 16.905 8.92632 16.9049",
    stroke: "#F8009E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/IconQuestion.e305edc729682db7ae268ea1a1c24373.svg";
export { ForwardRef as ReactComponent };